import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios'; // 引入axios

const store = new Vuex.Store({
    state: {
        wsWebChat: null, // websocket网诊链接
        wsTakeOrder: null, // websocket拍单链接
        webChatList: [], // 网诊聊天列表
        patientAvatar: null, // 会员微信头像
        patientIsOnline: 0, // 患者是否在线
        chatPageNum: 1, // 网诊聊天模块当前页
        chatTotal: 0, // 网诊聊天记录总条数
        contentText: '', // 医生发送的信息内容
        doctorOptions: [], // 医生列表
        doctorParams: {}, // 请求医生列表的参数
        webChatEndTime: null, // 获取聊天记录的endTime
        func1: function(_this, obj) {
            let params = {
                method: "post",
                url: `${_this.$shebaoUrl}/query_settlement`,
                data: obj,
            }
            setInterval(() => {
                axios(params).then(res => {
                    console.log(res, 888888);
                    // if (res.code == )
                }).catch(err => {})
            }, 1000);
        },
    }
})

export default store;